const _excluded = ["size"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
var Klarna24 = function Klarna24(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      d: "M34.543 2H5.457A3.457 3.457 0 0 0 2 5.457v13.086A3.457 3.457 0 0 0 5.457 22h29.086A3.457 3.457 0 0 0 38 18.543V5.457A3.457 3.457 0 0 0 34.543 2z",
      fill: "#FFB3C7",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M34.635 13.717a.857.857 0 0 0-.853.86c0 .476.382.861.853.861a.857.857 0 0 0 .853-.86.857.857 0 0 0-.853-.86zm-2.806-.665c0-.65-.55-1.178-1.23-1.178-.68 0-1.232.527-1.232 1.178 0 .65.551 1.178 1.231 1.178s1.231-.527 1.231-1.178zm.005-2.29h1.359v4.58h-1.359v-.293c-.384.264-.847.42-1.347.42a2.406 2.406 0 0 1-2.395-2.417 2.405 2.405 0 0 1 2.395-2.416c.5 0 .963.155 1.347.42v-.294zm-10.874.597v-.597h-1.39v4.58h1.393v-2.139c0-.72.775-1.109 1.313-1.109l.016.001v-1.332c-.552 0-1.06.238-1.332.596zm-3.465 1.693c0-.65-.551-1.178-1.231-1.178s-1.231.527-1.231 1.178c0 .65.55 1.178 1.23 1.178.68 0 1.232-.527 1.232-1.178zm.005-2.29h1.358v4.58H17.5v-.293c-.384.264-.848.42-1.347.42a2.406 2.406 0 0 1-2.395-2.417 2.405 2.405 0 0 1 2.395-2.416c.5 0 .963.155 1.347.42v-.294zm8.178-.123c-.543 0-1.056.17-1.4.64v-.517h-1.353v4.58h1.37v-2.407c0-.696.462-1.037 1.02-1.037.597 0 .94.36.94 1.028v2.415h1.357V12.43c0-1.066-.84-1.79-1.934-1.79v-.001zm-13.9 4.703h1.423v-6.62h-1.422v6.62zm-6.247.001h1.506V8.72H5.531v6.623zM10.8 8.72a5.293 5.293 0 0 1-1.54 3.76l2.08 2.864H9.48L7.219 12.23l.583-.441a3.815 3.815 0 0 0 1.524-3.07h1.474z",
      fill: "#0A0B09",
    })
  );
};
Klarna24.defaultProps = {
  width: "40",
  height: "24",
  viewBox: "0 0 40 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
var Klarna32 = function Klarna32(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      d: "M0 4a4 4 0 0 1 4-4h24a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4Z",
      fill: "#FFB3C7",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M28.26 13.34a.74.74 0 0 0 0 1.5c.4 0 .74-.34.74-.76a.74.74 0 0 0-.74-.74Zm-2.44-.58c0-.57-.47-1.02-1.06-1.02-.6 0-1.07.45-1.07 1.02 0 .56.48 1.02 1.07 1.02.59 0 1.06-.46 1.06-1.02Zm0-1.99h1.19v3.98h-1.18v-.26c-.33.23-.74.37-1.17.37a2.09 2.09 0 0 1-2.08-2.1 2.09 2.09 0 0 1 3.25-1.73v-.26Zm-9.43.52v-.52h-1.2v3.98h1.2v-1.86c0-.62.68-.96 1.14-.96h.02v-1.16c-.48 0-.92.21-1.16.52Zm-3 1.47c0-.57-.49-1.02-1.08-1.02-.59 0-1.06.45-1.06 1.02 0 .56.47 1.02 1.06 1.02.6 0 1.07-.46 1.07-1.02Zm0-1.99h1.18v3.98h-1.18v-.26c-.34.23-.74.37-1.17.37a2.09 2.09 0 0 1-2.08-2.1 2.09 2.09 0 0 1 3.25-1.73v-.26Zm7.1-.1c-.48 0-.92.14-1.22.55v-.45H18.1v3.98h1.18v-2.1c0-.6.4-.9.89-.9.52 0 .82.32.82.9v2.1h1.17v-2.53c0-.93-.72-1.55-1.67-1.55ZM8.42 14.75h1.24V9H8.42v5.75Zm-5.42 0h1.3V9H3v5.75ZM7.57 9a4.6 4.6 0 0 1-1.34 3.26l1.81 2.49H6.43l-1.97-2.7.51-.39A3.31 3.31 0 0 0 6.29 9h1.28Z",
      fill: "#000",
    })
  );
};
Klarna32.defaultProps = {
  width: "32",
  height: "24",
  viewBox: "0 0 32 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
const sizeMap = {
  24: Klarna24,
  32: Klarna32,
};
export function Klarna(_ref) {
  let { size = "24" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["24"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    throw new Error(
      "The '".concat(
        size,
        "' size is not supported by the 'Klarna' icon. Please use one of the available sizes: '24', '32'."
      )
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
